import { OrderListDesignTokens } from '../../../../types/orderlist';

export default {
    root: {
        gap: '1.125rem'
    },
    controls: {
        gap: '0.5rem'
    }
} as OrderListDesignTokens;
